export default __webpack_public_path__ + "images/graphics/bank-id.svg";